<template>
  <nav>
    <div class="version">
      <span>Versão: v{{ version }}</span>
    </div>
    <ul class="nav flex-column">
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'painel' }" to="/"><i class="bi bi-house-door-fill me-2"></i> Início</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'sales' || route.name === 'sale-detail' }" to="/sales"><i class="bi bi-person-vcard-fill me-2"></i> Vendas</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'produtos' }" to="/products"><i class="bi bi-box-seam-fill me-2"></i> Produtos</router-link>
      </li>
      <li class="nav-item" v-if="servicesEnabled">
          <router-link class="itemmenu" :class="{ active: route.name === 'services' }" to="/services"><i class="bi bi-tools me-2"></i> Serviços</router-link>
      </li>
      <li class="nav-item" v-if="servicesEnabled">
          <router-link class="itemmenu" :class="{ active: route.name === 'budgets' }" to="/budgets"><i class="bi bi-file-earmark-text-fill me-2"></i> Orçamentos</router-link>
      </li>
      <li class="nav-item" v-if="servicesEnabled">
          <router-link class="itemmenu" :class="{ active: route.name === 'agenda' }" to="/agenda"><i class="bi bi-calendar-week-fill me-2"></i> Agenda</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'movement' || route.name === 'movement-detail' }" to="/movements"><i class="bi bi-archive-fill me-2"></i> Movimentações</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'reports' }" to="/reports"><i class="bi bi-bar-chart-line-fill me-2"></i> Relatórios</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'fornecedores' }" to="/suppliers"><i class="bi bi-person-vcard-fill me-2"></i> Fornecedores</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'clientes' }" to="/costumers"><i class="bi bi-person-bounding-box me-2"></i> Clientes</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'operators' }" to="/operators"><i class="bi bi-pc-display-horizontal me-2"></i> Operadores</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'stores' }" to="/stores"><i class="bi bi-shop me-2"></i> Lojas</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'cashiers' || route.name === 'cashier-detail' }" to="/cashiers"><i class="bi bi-cash-stack me-2"></i> Caixas</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'payment-methods' }" to="/payment-methods"><i class="bi bi-credit-card-2-front-fill me-2"></i> Formas de Pagamento</router-link>
      </li>
      <li class="nav-item">
          <router-link class="itemmenu" :class="{ active: route.name === 'settings' }" to="/settings"><i class="bi bi-gear-fill me-2"></i> Configurações</router-link>
      </li>
      <li class="nav-item">
          <a class="itemmenu" @click="logout"><i class="bi bi-box-arrow-left me-2"></i> Sair</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from '@/services/auth.js';
import { configuracoes } from '@/models/configuracoes';
import router from '@/router';

export default {
    name: 'Navbar',
    setup() {
      const auth = useAuth();
      const route = useRoute();
      const version = '0.1.0'
      const Configuracoes = configuracoes();
      const servicesEnabled = ref(false);

      function logout() {
        auth.setToken('');
        auth.setUser('');
        router.push({name: 'login'});
      }

      onMounted(async () => {
        const dados = await Configuracoes.get();
        servicesEnabled.value = !!dados?.services_enabled;
      });

      return {logout, version, route, servicesEnabled}
    }
}
</script>

<style scoped>
  .version {
    color: #7d868f;
    font-size: 12px;
    padding: 0 0.5em 1em;
  }

  .itemmenu {
    padding: 0.6em 0.75em;
    margin-bottom: 0.15em;
    border-radius: 10px;
    color: #a8a8a8;
    display: block;
    text-decoration: none;
    font-size: 0.95rem;
    transition: background-color 0.15s ease, color 0.15s ease;
  }

  .itemmenu:hover {
    color: #ffffff;
    background-color: rgba(255, 255, 255, 0.08);
  }

  .itemmenu.active {
    color: #ffffff;
    background-color: var(--brand, #0d6efd);
  }
</style>
